const pageBackground = {
  minHeight: '100vh',
  background: '#f5f7fb',
  padding: '3rem 2rem',
  color: '#0f172a',
};

const panelStyle = {
  background: '#ffffff',
  border: '1px solid #e5e7eb',
  boxShadow: '0 20px 50px rgba(15, 23, 42, 0.08)',
  borderRadius: '16px',
  padding: '1.75rem',
};

export default function Categories() {
  return (
    <div style={pageBackground}>
      <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '1rem' }}>
          <span
            style={{
              display: 'inline-block',
              padding: '0.35rem 0.85rem',
              borderRadius: '999px',
              background: '#e0f2fe',
              color: '#0f172a',
              letterSpacing: '0.08em',
              fontSize: '0.8rem',
              textTransform: 'uppercase',
              border: '1px solid #bae6fd',
            }}
          >
            Categories
          </span>
        </div>
        <div style={panelStyle}>
          <h1 style={{ fontWeight: 700, marginBottom: '0.5rem' }}>Expense Categories</h1>
          <p style={{ color: '#cbd5e1', maxWidth: '42rem', marginBottom: '1.25rem' }}>
            Organize bill types, payment rails, and more. Category management is coming soon.
          </p>
          <div style={{ ...panelStyle, padding: '1.1rem', marginTop: '0.5rem' }}>
            <p style={{ color: '#94a3b8', margin: 0 }}>
              We&apos;re setting up category creation, editing, and tagging workflows. Check back shortly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
